import * as Oidc from 'oidc-client';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Settings } from '../Settings';

export class SilentRenew extends React.Component<any, any> {
  componentWillMount() {
    const manager = new Oidc.UserManager(Settings);

    // console.log('Renewing token silently');
    manager.signinSilentCallback();
  }
  render() {
    return null;
  }
}
